import React, { useState } from "react";
import "../css/RejectionModal.css";

/**
 * RejectionModal
 * Props:
 *   status   — "rejected" | "cancelled"
 *   itemName — display name of the item being rejected
 *   onConfirm(note) — called with the note text
 *   onCancel()
 */
const RejectionModal = ({ status, itemName, onConfirm, onCancel }) => {
  const [note, setNote] = useState("");

  const isRejected  = status === "rejected";
  const color       = isRejected ? "#c0392b" : "#e67e22";
  const icon        = isRejected ? "❌" : "🚫";
  const label       = isRejected ? "Rejection" : "Cancellation";

  return (
    <div className="rm-bg" onClick={onCancel}>
      <div className="rm-modal" onClick={e => e.stopPropagation()}>
        <div className="rm-header" style={{ borderColor: color }}>
          <span className="rm-icon">{icon}</span>
          <div>
            <h3 className="rm-title" style={{ color }}>
              {label} Reason Required
            </h3>
            {itemName && (
              <p className="rm-item-name">{itemName}</p>
            )}
          </div>
        </div>

        <p className="rm-desc">
          Please provide a reason for {isRejected ? "rejecting" : "cancelling"} this request.
          This note will be saved and visible in the record.
        </p>

        <div className="rm-field">
          <label className="rm-label">
            {label} Note <span style={{ color: "#e74c3c" }}>*</span>
          </label>
          <textarea
            className="rm-textarea"
            rows={4}
            value={note}
            onChange={e => setNote(e.target.value)}
            placeholder={
              isRejected
                ? "e.g. Documents incomplete, address not verifiable, duplicate request…"
                : "e.g. Applicant withdrew request, no longer needed…"
            }
            autoFocus
          />
        </div>

        <div className="rm-actions">
          <button className="rm-cancel-btn" onClick={onCancel}>
            Go Back
          </button>
          <button
            className="rm-confirm-btn"
            style={{ background: color }}
            onClick={() => {
              if (!note.trim()) {
                alert("Please enter a reason before confirming.");
                return;
              }
              onConfirm(note.trim());
            }}
          >
            {icon} Confirm {label}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectionModal;